import React, { Fragment } from 'react';
import i18n from '../../../../i18n/i18n.js';

export default field => {
    let lng = field.lng;
    let message = '';
    let isFieldInvalid =
        field.meta.touched && field.meta.error && !field.meta.active;
    let className = isFieldInvalid ? 'invalid' : '';
    let iconClassName = '';
    if (field.iconName) {
        iconClassName = `ipic_${field.iconName} ${className}`;
    } else {
        iconClassName = `ipic_${field.input.name} ${className}`;
    }

    if (field.meta.error === 'required') {
        message = i18n.t('required_field', { lng });
    } else if (field.meta.error === 'please enter a correct email') {
        message = i18n.t('email_field', { lng });
    } else if (field.meta.error === 'must be at least 8 characters long') {
        message = i18n.t('minpass_field', { lng });
    } else if (field.meta.error === 'must be at least 2 characters long') {
        message = i18n.t('minname_field', { lng });
    } else if (field.meta.error === 'the password did not match') {
        message = i18n.t('matchPass', { lng });
    } else {
        message;
    }

    let focusColor = '#d7dde5';
    if (field.active) {
        focusColor = field.primaryColor ? field.primaryColor : '#00aae6';
    }

    let iconColor = '#d7dde5';
    if (field.input.value !== '') {
        iconColor = field.primaryColor ? field.primaryColor : '#00aae6';
    }

    return field.className ? (
        <div className={field.className}>
            <input
                {...field.input}
                type={field.type}
                placeholder=" "
                id={field.input.name}
                className={className}
                onFocus={e => {
                    field.handleFocus(e);
                    field.input.onFocus(e);
                }}
                onBlur={e => {
                    field.handleFocus(e);
                    field.input.onBlur(e);
                }}
                style={{ borderBottom: '1px solid ' + focusColor }}
            />
            <i
                className={iconClassName}
                style={{ color: isFieldInvalid ? '' : iconColor }}
            />
            <label htmlFor={field.input.name}>{field.label}</label>

            {field.meta.touched && field.meta.error && !field.meta.active ? (
                <p className="validation-error">{message}</p>
            ) : (
                ''
            )}
        </div>
    ) : (
        <Fragment>
            <input
                {...field.input}
                type={field.type}
                placeholder=" "
                id={field.input.name}
                className={className}
                onFocus={e => {
                    field.handleFocus(e);
                    field.input.onFocus(e);
                }}
                onBlur={e => {
                    field.handleFocus(e);
                    field.input.onBlur(e);
                }}
                style={{ borderBottom: '1px solid ' + focusColor }}
            />
            <i
                className={iconClassName}
                style={{ color: isFieldInvalid ? '' : iconColor }}
            />
            <label
                htmlFor={field.input.name}
                id={field.labelId ? field.labelId : ''}
            >
                {field.label}
            </label>
            {field.meta.touched && field.meta.error && !field.meta.active ? (
                <p className="validation-error">{message}</p>
            ) : (
                ''
            )}
        </Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/TextInput/index.js